<template>
  <div class="clear">
    <FormList
      :list="formList"
      :data="formData"
      :onChange="onInputChange"
    >
    </FormList>
    <div class="button" @click="handleClick('copyClear')">
      抄税清卡
    </div>
  </div>
</template>

<script>
import FormList from '@components/FormList'
import { renderTextWithConfig } from '@utils/basicUtil'
import { invoiceRequest } from '@services'
import { TOOLS_TYPE } from '@assets/config'
import { Notify } from 'vant'
export default {
  components: {
    FormList,
    [Notify.name]: Notify
  },
  props: {
    currentCompany: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      deviceOnlineStatus: false,
      formData: {}
    }
  },
  computed: {
    formList () {
      return [
        {
          type: 'info',
          field: 'name',
          label: '企业名称'
        },
        {
          type: 'info',
          field: 'machineNo',
          label: '税盘编号'
        },
        {
          type: 'info',
          field: 'taxNo',
          label: '企业税号'
        },
        {
          type: 'info',
          field: 'nature',
          label: '企业类型',
          render: (text) => text === 1 ? '一般纳税人' : '小规模纳税人'
        },
        {
          type: 'info',
          field: 'toolsType',
          label: '税盘类型',
          render: (text) => renderTextWithConfig(text, TOOLS_TYPE)
        },
        {
          type: 'info',
          field: 'bankNo',
          label: '税盘状态',
          render: () => this.deviceOnlineStatus ? '在线' : '离线'
        },
        {
          type: 'info',
          field: 'upLoadStatus',
          label: '上传状态',
          render: text => text === 0 ? '已上传' : '未上传'
        },
        {
          type: 'info',
          field: 'copyStatus',
          label: '抄报状态',
          render: text => text === 0 ? '已抄报' : '未抄报'
        },
        {
          type: 'info',
          field: 'clearStatus',
          label: '清卡状态',
          render: text => text === 0 ? '已清卡' : '未清卡'
        }
      ]
    }
  },
  watch: {
    currentCompany (value) {
      this.formData = this.currentCompany || {}
    }
  },
  created () {},
  mounted () {
    this.formData = this.currentCompany || {}
    console.log(this.currentCompany)
    this.getClearList()
    this.queryOnLine()
  },
  activated () {},
  updated () {},
  methods: {
    onInputChange ({ e, field }) {
      console.log(e, field)
    },
    async queryOnLine () {
      const result = await invoiceRequest.blank.queryOnLine({})
      if (result.success) {
        this.deviceOnlineStatus = result.result
      }
    },
    async getClearList () {
      const params = {
        companyName: this.currentCompany.name,
        current: 1,
        size: 25
      }
      const result = await invoiceRequest.blank.getClearList(params)
      if (result.success) {
        console.log(result.result)
        const recordArr = result.result.records.filter(v => v.taxName === this.currentCompany.name && v.macCode === this.currentCompany.machineNo)
        if (recordArr.length) {
          const record = recordArr[0] || {}
          const { upLoadStatus, copyStatus, clearStatus } = record
          this.formData = {
            ...this.formData,
            upLoadStatus,
            copyStatus,
            clearStatus
          }
        }
      }
    },
    async reportRefreshTax () {
      const params = {
        companyId: this.currentCompany.id,
        deviceNo: this.currentCompany.machineNo,
        taxNo: this.currentCompany.taxNo
      }
      const result = await invoiceRequest.blank.reportRefreshTax(params)
      if (result.success) {
        Notify({ type: 'success', message: '操作成功' })
      } else {
        Notify({ type: 'danger', message: result.message })
      }
    },
    handleClick (type) {
      if (type === 'copyClear') {
        this.reportRefreshTax()
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"></style>
